import React from 'react';
import { CheckIcon, PackageCheckIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-ivory px-5 py-16 md:px-8 md:py-24" data-id="element-310" data-mp="1845a69vlz0zo">
      <div className="mx-auto max-w-6xl" data-id="element-311" data-mp="181slldvchsdn">
        <h2 className="mx-auto max-w-4xl text-center font-serif text-[1.85rem] font-extrabold leading-tight text-navy-900 sm:text-4xl md:text-5xl" data-id="element-312" data-mp="1c4p7bdg6m4lt">
          Everything you need to organize veneer complication cases in one practical system
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-313" data-mp="24s1qrer1pwaw">
          <strong className="text-navy-900" data-id="element-314" data-mp="1qwhays6m5u7p">6 action-focused clinical volumes.</strong> Each
          focuses on a specific part of the assessment or corrective planning process —
          prioritizing practical workflows, decision tools, documentation templates, and
          case-planning resources.
        </p>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-315" data-mp="3o86n6ec91w9n">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy-900/10" data-id="element-316" data-mp="3o9zu7uqryii6">
              <div className="bg-navy-900 px-6 py-5 sm:px-8" data-id="element-317" data-mp="218efigvqusa">
                <span className="inline-block rounded-md bg-gold-400 px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-navy-900" data-id="element-318" data-mp="1ylwqq09yywc">
                  Volume {v.number}
                </span>
                <h3 className="mt-3 font-serif text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-319" data-mp="azab5ltkz19r">{v.title}</h3>
                <p className="mt-2 text-base font-semibold text-gold-300" data-id="element-320" data-mp="kr6jrqtam9s8">{v.tagline}</p>
              </div>
              <div className="flex flex-1 flex-col px-6 py-6 sm:px-8" data-id="element-321" data-mp="frtochocvue1">
                <p className="text-base leading-relaxed text-muted" data-id="element-322" data-mp="fupnuafuqr4l">{v.description}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-navy-900" data-id="element-323" data-mp="tq1t3brmvzzr">Inside this volume:</p>
                <ul className="mt-3 space-y-2.5" data-id="element-324" data-mp="wtr3p0fw96zs">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-base text-ink" data-id="element-325" data-mp="wrwhlisvz8u4">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-326" data-mp="11t3svru8mq5j" />
                      {item}
                    </li>)}
                </ul>
                <div className="mt-auto pt-6" data-id="element-327" data-mp="1bkgjyh87pcai">
                  <div className="rounded-2xl border border-gold-400 bg-gold-200/40 p-5" data-id="element-328" data-mp="1fj77bwmvlfkf">
                    <p className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-wide text-gold-600" data-id="element-329" data-mp="1kiip98yzar3l">
                      <PackageCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-330" data-mp="1piy11w3m3qjg" />
                      Your practical deliverable
                    </p>
                    <p className="mt-2 text-base font-semibold leading-relaxed text-navy-900" data-id="element-331" data-mp="3ra1eet4vzj7p">{v.deliverable}</p>
                    <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-332" data-mp="2yos64p5kzl">{v.note}</p>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCTA label="Give Me All 6 Clinical Volumes" data-id="element-333" data-mp="28mhytq4ivh06" />
      </div>
    </section>;
}